import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

interface IProps {
    closeDialog: any;
}

const SubmitReportConfirmationDialog: React.FunctionComponent<IProps> = (props) => {
    const { t: tLang, i18n: i18nLang } = useTranslation();

    useEffect(() => {
        window.addEventListener("keyup", (evt: any) => {
            evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = evt.key === "Escape" || evt.key === "Esc";
            } else {
                isEscape = evt.keyCode === 27;
            }
            if (isEscape) {
                props.closeDialog();
            }
        });
        return () => {
            window.removeEventListener("keyup", () => {});
        };
    });

    return (
        <React.Fragment>
            <div className="dialog-header">
                <h1>{tLang("supportSection.generalSupportWidget.reportIdentityThreatWidget.confirmationMessageCard.title")}</h1>
            </div>

            <div className="dialog-body">
                <p>{tLang("supportSection.generalSupportWidget.reportIdentityThreatWidget.confirmationMessageCard.message")}</p>
            </div>

            <div className="dialog-footer">
                <div className="row between-xs">
                    <div className="col-xs col-no-gutter flex-grow-null"></div>
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button
                            type="button"
                            className="btn-default btn-primary"
                            id="btn-submit-upgrade-confirmation"
                            onClick={() => {
                                props.closeDialog();
                            }}
                        >
                            <span className="btn-text">
                                {tLang("supportSection.generalSupportWidget.reportIdentityThreatWidget.confirmationMessageCard.okButton")}
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};
export default SubmitReportConfirmationDialog;
